import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  private readonly baseTitle = 'AI Football Predictions That Actually Win | Dimers Platinum';
  private readonly defaultDescription = 'Unlock the power of AI football predictions with Dimers Platinum. Our artificial intelligence football predictor delivers smarter picks and real results.';
  private readonly defaultImageUrl = 'https://imgix.cosmicjs.com/984ff5e0-4be0-11f0-8d02-d7de9448d6b1-social-sharing-photo.png';
  private readonly siteUrl = 'https://ai.dimers.com/';

  constructor(
    private titleService: Title,
    private metaService: Meta
  ) { }


  updateTags(title: string, description?: string, imageUrl?: string): void {
    const pageTitle = title ? `${title} | ${this.baseTitle}` : this.baseTitle;
    const pageDescription = description || this.defaultDescription;
    const pageImageUrl = imageUrl || this.defaultImageUrl;

    this.titleService.setTitle(pageTitle);

    this.metaService.updateTag({ name: 'description', content: pageDescription });

    this.metaService.updateTag({ property: 'og:title', content: pageTitle });
    this.metaService.updateTag({ property: 'og:description', content: pageDescription });
    this.metaService.updateTag({ property: 'og:image', content: pageImageUrl });
    this.metaService.updateTag({ property: 'og:url', content: this.siteUrl });
    this.metaService.updateTag({ property: 'og:type', content: 'website' });

    this.metaService.updateTag({ name: 'twitter:card', content: 'summary_large_image' });
    this.metaService.updateTag({ name: 'twitter:title', content: pageTitle });
    this.metaService.updateTag({ name: 'twitter:description', content: pageDescription });
    this.metaService.updateTag({ name: 'twitter:image', content: pageImageUrl });
  }
}